import React, { useState, useEffect, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { Link } from "react-router-dom";
import axios from "axios";
import Header from "./components/AdminHeader";


const ExpenditureKitchenDetails = () => {
  const id = localStorage.getItem("get_kitchen_id_exp");
  const tableRef = useRef(null);


  const [requisitionList, setRequisitionList] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editedStockName, setEditedStockName] = useState("");
  const [getEditedstock_id, setEditedstock_id] = useState("");
  const [getUnits, setEditedUnits] = useState("");
  const [editedQuantity, setEditedQuantity] = useState("");
  const [editedDate, setEditedDate] = useState("");
  const [editedId, setEditedId] = useState("");
  const [editedSourceType, setEditedSourceType] = useState("main");
  const [isExportingToPDF, setIsExportingToPDF] = useState(false);


  const itemsPerPage = 10;

  useEffect(() => {
    fetchRequisitionList();
  }, []);

  const fetchRequisitionList = async (startDate = "", endDate = "") => {
    let djangoUrl = `https://ims-backend.indevconsultancy.in/api/daily-expendituress/${id}/`;

    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    if (params.toString()) djangoUrl += `?${params.toString()}`;

    // ===== 2) PHP: sub-kitchen daily expenditures (KitchenType 0 + 1) =====
    const phpBase = `https://api-ims.indevconsultancy.in/sub-expenditures-list.php`;
    const phpParams = (kt) => {
      const p = new URLSearchParams();
      p.append("kitchen_id", id);
      p.append("KitchenType", kt);
      if (startDate) p.append("start_date", startDate);
      if (endDate) p.append("end_date", endDate);
      return p.toString();
    };

    try {
      const [djangoRes, php0Res, php1Res] = await Promise.allSettled([
        axios.get(djangoUrl),
        axios.get(`${phpBase}?${phpParams(0)}`),
        axios.get(`${phpBase}?${phpParams(1)}`),
      ]);

      // ----- Normalize Django rows (Main Kitchen) -----
      const mainRows =
        djangoRes.status === "fulfilled" && Array.isArray(djangoRes.value.data)
          ? djangoRes.value.data.map((r) => ({
            ...r,
            source: "Main Kitchen",
            source_type: "main",
            created_at: r.created_at,
          }))
          : [];

      // ----- Normalize PHP rows (Sub Kitchen) -----
      const normalizeSub = (resp) => {
        if (resp.status !== "fulfilled") return [];
        const data = resp.value.data;
        const list = Array.isArray(data) ? data : data?.data;
        if (!Array.isArray(list)) return [];
        return list.map((r) => ({
          dailyexpenditure_id: `sub_${r.id}`, // unique id, prefix to avoid clash
          stock_id: r.kitchestock,
          stock_name: r.stock_name,
          units: r.units || "",
          expenditure_quantity: r.expenditure_quantity,
          created_at: r.add_date,
          remarks: r.remarks || "",
          source: `Sub Kitchen${r.subKitchen_name ? ` (${r.subKitchen_name})` : ""}`,
          source_type: "sub",
          _rawId: r.id, // keep original id for edit/delete on sub
        }));
      };
      const subRows = [...normalizeSub(php0Res), ...normalizeSub(php1Res)];

      // ----- Merge and sort by date desc -----
      const merged = [...mainRows, ...subRows].sort(
        (a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0)
      );

      setRequisitionList(merged);
      setCurrentPage(1);
    } catch (err) {
      console.error("Failed to fetch requisition list:", err);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchRequisitionList(startDate, endDate);
  };

  const exportToCSV = () => {
    if (!filteredList.length) return;

    const headers = ["S.No.", "Stock Name", "Quantity", "Expenditure Date", "Remark", "Source"];
    const rows = filteredList.map((item, index) => {
      const date = new Date(item.created_at);
      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;
      return [
        index + 1,
        `${item.stock_name} (${item.units || ""})`,
        item.expenditure_quantity,
        formattedDate,
        (item.remarks || "").replace(/,/g, " "),
        item.source || "",
      ];
    });

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "filtered_kitchen_expenditure.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToPDF = async () => {
    const input = tableRef.current;
    if (!input) return;

    try {
      const canvas = await html2canvas(input, {
        scale: 2, // higher scale = better quality
      });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);
      pdf.save("daily_kitchen_report.pdf");
    } catch (err) {
      console.error("PDF export failed:", err);
    }
  };


  // Filter by stock name
  const filteredList = requisitionList.filter((item) =>
    item.stock_name.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  // Pagination after filtering
  const paginatedList = filteredList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  return (
    <>
      <Header />
      <div className="container-fluid px-2">
        <div className="row align-items-center justify-content-between py-2">
          <div className="col-md-6 col-6">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
              </ol>
            </nav>
          </div>
          <div className="col-md-6 col-6 text-end">
            <span className="fs-1">Kitchen View</span>
          </div>
        </div>

        <div className="card">
          <div className="card-header border-info">
            <form onSubmit={handleSearch}>
              <div className="row g-3">
                <div className="col-lg">
                  <input
                    type="date"
                    className="form-control"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    placeholder="Start Date"
                  />
                </div>

                <div className="col-lg">
                  <input
                    type="date"
                    className="form-control"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    placeholder="End Date"
                  />
                </div>

                <div className="col-lg">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Stock Name"
                    value={searchKeyword}
                    onChange={(e) => setSearchKeyword(e.target.value)}
                  />
                </div>

                <div className="col-lg-2">
                  <button type="submit" className="btn btn-primary w-100">
                    Search
                  </button>
                </div>

                <div className="col-lg-1">
                  <button
                    type="button"
                    className="btn btn-outline-dark w-100"
                    onClick={() => {
                      setStartDate("");
                      setEndDate("");
                      setSearchKeyword("");
                      fetchRequisitionList();
                    }}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>

          <div className="card-body">
            <div className="row g-0 align-items-center">
              <div className="d-flex justify-content-between">
                <h6 className="fw-bold mb-0">
                  Total Item(s): <span>{filteredList.length}</span>
                </h6>
                <div>
                  <button
                    className="btn btn-primary btn-sm mb-1 me-1"
                    onClick={exportToPDF}
                  >
                    <i className="fas fa-file me-1"></i>
                    Daily Export Report
                  </button>
                  <button
                    className="btn btn-primary btn-sm mb-1"
                    onClick={exportToCSV}
                  >
                    <i className="fas fa-file me-1"></i>
                    Export
                  </button>

                </div>



              </div>
            </div>

            <div className="table-responsive scrollbar" ref={tableRef}>
              <table className="table text-center table-bordered table-striped fs--1 mb-0">
                <thead className="bg-primary text-white">
                  <tr>
                    <th>S.No.</th>
                    <th>Stock Name</th>
                    <th>Quantity</th>
                    <th>Expenditure Date</th>
                    <th>Remark</th>
                    <th>Source</th>
                    <th style={isExportingToPDF ? { display: "none" } : {}}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedList.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-center">
                        Loading or no data available
                      </td>
                    </tr>
                  ) : (
                    paginatedList.map((item, index) => (
                      <tr key={index}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>
                          {item.stock_name} ({item.units})
                        </td>
                        <td>{item.expenditure_quantity}</td>
                        <td>
                          {(() => {
                            const d = new Date(item.created_at);
                            return `${d.getDate().toString().padStart(2, "0")}-${(d.getMonth() + 1)
                              .toString().padStart(2, "0")}-${d.getFullYear()}`;
                          })()}
                        </td>
                        <td>
                          {item.remarks && item.remarks.trim() !== "" ? item.remarks : "-"}
                        </td>
                        <td>
                          <span
                            className={`badge ${item.source_type === "sub" ? "bg-info" : "bg-success"
                              }`}
                          >
                            {item.source}
                          </span>
                        </td>
                        <td style={isExportingToPDF ? { display: "none" } : {}}>
                          <button
                            className="btn btn-sm me-1 text-white"
                            style={{ background: "#28a745" }}
                            onClick={() => {
                              const idForEdit =
                                item.source_type === "sub"
                                  ? item._rawId
                                  : item.dailyexpenditure_id;
                              if (!idForEdit) {
                                alert("No ID found for this item.");
                                return;
                              }

                              setEditedId(idForEdit);
                              setEditedSourceType(item.source_type || "main");
                              setEditedStockName(item.stock_name);
                              setEditedstock_id(item.stock_id);
                              setEditedUnits(item.units); // Fixed typo
                              setEditedQuantity(item.expenditure_quantity);
                              setEditedDate(item.created_at?.slice(0, 10));
                              setShowModal(true);
                            }}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-sm text-white"
                            style={{ background: "#8b1a1a" }}
                            onClick={async () => {
                              if (!window.confirm("Are you sure you want to delete this stock?")) return;
                              try {
                                if (item.source_type === "sub") {
                                  // Sub-kitchen: call PHP delete API
                                  await axios.post(
                                    "https://api-ims.indevconsultancy.in/sub-expenditures-delete.php",
                                    { id: item._rawId },
                                    { headers: { "Content-Type": "application/json" } }
                                  );
                                } else {
                                  // Main kitchen: call Django delete API
                                  await axios.post(
                                    "https://ims-backend.indevconsultancy.in/api/daily-expenditur-delete/",
                                    { dailyexpenditure_id: item.dailyexpenditure_id },
                                    { headers: { "Content-Type": "application/json" } }
                                  );
                                }
                                fetchRequisitionList();
                              } catch (err) {
                                console.error("Delete failed", err.response?.data || err.message);
                                alert("Delete failed. See console for details.");
                              }
                            }}
                          >
                            Delete
                          </button>

                        </td>
                      </tr>
                    ))
                  )}
                </tbody>

              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="btn btn-outline-primary btn-sm"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div >

      {showModal && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Stock</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Stock Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editedStockName}
                    onChange={(e) => setEditedStockName(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Quantity</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editedQuantity}
                    onChange={(e) => setEditedQuantity(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Expenditure Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={editedDate}
                    onChange={(e) => setEditedDate(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  // onClick={async () => {
                  //   try {
                  //     const response = await fetch(
                  //       "https://api-ims.indevconsultancy.in/update_expenditurerv1.php",
                  //       {
                  //         method: "POST",
                  //         headers: {
                  //           "Content-Type": "application/json"
                  //         },
                  //         body: JSON.stringify({
                  //           dailyexpenditure_id: editedId,
                  //           stock_name: editedStockName,
                  //           expenditure_quantity: editedQuantity,
                  //           stock_id: getEditedstock_id,
                  //           created_at: editedDate,
                  //           units: getUnits
                  //         })
                  //       }
                  //     );

                  //     const result = await response.json();
                  //     console.log(result);

                  //     if (response.ok) {
                  //       setShowModal(false);
                  //       fetchRequisitionList();
                  //     } else {
                  //       console.error("Update failed", result);
                  //     }

                  //   } catch (err) {
                  //     console.error("Network error", err);
                  //   }
                  // }}
                  onClick={async () => {
                    try {
                      let url, payload;
                      if (editedSourceType === "sub") {
                        // Sub-kitchen: call new PHP update API
                        url = "https://api-ims.indevconsultancy.in/sub-expenditures-update.php";
                        payload = {
                          id: editedId,
                          expenditure_quantity: editedQuantity,
                          add_date: editedDate,
                        };
                      } else {
                        // Main kitchen: existing PHP update
                        url = "https://api-ims.indevconsultancy.in/update_expenditurerv1.php";
                        payload = {
                          dailyexpenditure_id: editedId,
                          stock_name: editedStockName,
                          expenditure_quantity: editedQuantity,
                          stock_id: getEditedstock_id,
                          created_at: editedDate,
                          units: getUnits,
                        };
                      }

                      const response = await fetch(url, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify(payload),
                      });

                      const result = await response.json();
                      console.log(result);

                      if (response.ok) {
                        setShowModal(false);
                        fetchRequisitionList();
                      } else {
                        console.error("Update failed", result);
                        alert("Update failed.");
                      }
                    } catch (err) {
                      console.error("Network error", err);
                      alert("Network error during update.");
                    }
                  }}
                >
                  Save Changes
                </button>

                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}> Cancel </button>
              </div>
            </div>
          </div>
        </div>
      )
      }
    </>
  );
};

export default ExpenditureKitchenDetails;
